import styled from "styled-components";
import { Link } from "react-router-dom";
import { media } from "../../media";
import { useAuth } from "../../hooks/useAuth";
import Header from "../../common/header";
import Layout from "../../common/Layout";
import { useEffect, useState } from "react";
import { IsPlatform } from "../../type/album";
import { platform, useAlbum } from "../../hooks/useAlbum";

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const { currentDocs, searchByPlatform } = useAlbum();

  const onClickTag = (platform: IsPlatform) => {
    searchByPlatform(platform);
    setIsOpen(true);
  };

  const onClickNow = () => {
    setIsOpen(true);
  };

  useEffect(() => {
    setIsOpen(false);
  }, [isOpen]);

  return (
    <Layout isOpen={isOpen}>
      <HomeWrap>
        <Header />
        <div className="Banner">
          <div className="Today">
            <p>Recent</p>
          </div>
          <div className="TodayWrap">
            {currentDocs && currentDocs[0] && (
              <div className="TodayInner" onClick={onClickNow}>
                <p>{`${currentDocs[0].title} - ${currentDocs[0].username}`}</p>
              </div>
            )}
          </div>
        </div>
        <div className="Nav">
          <div className="LeftLine"></div>
          <div className="Main">
            <h2 className="Play" onClick={() => setIsOpen(true)}>
              PLAY
            </h2>
            <Link to={"/album"}>
              <h2>ALBUM</h2>
            </Link>
            <Link to={user.username ? "/admin" : "/admin/login"}>
              <h2>{user.username || "LOGIN"}</h2>
            </Link>
          </div>
        </div>
        <div className="Category">
          <div className="CategoryInner">
            {platform.map((e, i) => (
              <div key={i}>
                <p className="Platform" onClick={() => onClickTag(e)}>
                  {e.slice(0, 1).toUpperCase() + e.slice(1)}
                </p>
                <p>,&nbsp;</p>
              </div>
            ))}
            <div>
              <p>etc</p>
            </div>
          </div>
        </div>
        <footer className="Footer">
          <p>綠園</p>
          <Link to={"https://instagram.com/no_kwon?igshid=YjNmNGQ3MDY="}>
            <p>@no_kwon</p>
          </Link>
        </footer>
      </HomeWrap>
    </Layout>
  );
};

export default Home;

const HomeWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  ${media.desktop`
    width: 393px;
  `}
  .Banner {
    height: 240px;
    padding: 40px 0px 0px 0px;
    border-bottom: 1px solid #314af3;
    .Today {
      width: fit-content;
      padding: 8px 24px;
      background-color: #314af3;
      p {
        color: white;
        font-family: gmarket-sans-medium;
        font-size: 16px;
      }
    }
    .TodayWrap {
      padding: 12px 0px 0px 24px;
      .TodayInner {
        width: fit-content;
        cursor: pointer;
        p {
          font-family: gmarket-sans-medium;
          font-size: 18px;
        }
      }
    }
  }

  .Nav {
    display: flex;
    height: 180px;
    .LeftLine {
      width: 12px;
      background-color: #314af3;
    }
    .Main {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 28px;
      padding: 24px 12px;
      h2 {
        width: fit-content;
        font-family: nexa-bold;
        font-size: 24px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .Category {
    height: 150px;
    width: calc(100% -12px);
    margin-left: 12px;
    padding: 16px 0px 16px 12px;
    background-color: #314af3;
    color: white;
    display: flex;
    .CategoryInner {
      // RightLine 있을때 기준
      width: calc(100% - 12px);
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      div {
        display: flex;
        height: fit-content;
        margin-bottom: 2px;
        p {
          font-size: 18px;
          font-family: nexa-bold;
        }
        .Platform {
          &:hover {
            background-color: white;
            color: #314af3;
            cursor: pointer;
          }
        }
      }
    }
  }

  .Footer {
    width: 100%;
    left: 0px;
    padding: 0px 24px;
    margin: 148px 0px 24px 0px;
    display: flex;
    justify-content: space-between;
    @media (min-height: 790px) {
      width: 100vw;
      position: absolute;
      bottom: 0px;
    }
    ${media.desktop`
      width: 393px;
    `}
    p {
      cursor: pointer;
    }
  }
`;
